import { render, staticRenderFns } from "./IconColumn.vue?vue&type=template&id=f6258d6a&"
import script from "./IconColumn.vue?vue&type=script&lang=js&"
export * from "./IconColumn.vue?vue&type=script&lang=js&"
import style0 from "./IconColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports